var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    attrs: {
      buttons: _vm.buttons,
      permissions: _vm.permissions,
      parameters: [{ key: "linkedid", value: _vm.linkedid }]
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.more.title) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "prelative min-h-100" },
              [
                _c("preloader", { attrs: { display: _vm.loading } }),
                _vm._v(" "),
                !_vm.loading
                  ? _c("div", {
                      attrs: { id: "two-columns-v1" },
                      domProps: { innerHTML: _vm._s(_vm.htmlData) }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }